import React from 'react';
import { Breadcrumb } from 'antd';

/**
 * نوار مسیر ناوبری — کلیک روی هر پله به همان صفحه می‌رود
 */
const EntityBreadcrumb = ({ trail = [], onNavigate, className = '' }) => {
  if (!trail.length) return null;

  const items = trail.map((crumb, index) => {
    const isLast = index === trail.length - 1;
    const title = isLast ? (
      <span className="text-gray-700 dark:text-gray-200 font-medium" style={{ fontFamily: 'CustomFont' }}>
        {crumb.label}
      </span>
    ) : (
      <button
        type="button"
        onClick={() => onNavigate?.(index)}
        className="text-brand-primary hover:text-brand-primary-hover bg-transparent border-0 p-0 cursor-pointer font-medium transition-colors"
        style={{ fontFamily: 'CustomFont' }}
      >
        {crumb.label}
      </button>
    );

    return {
      key: crumb.path || index,
      title,
    };
  });

  return (
    <div
      className={`px-4 sm:px-6 py-2.5 bg-gray-50/90 dark:bg-gray-900/40 border-b border-gray-100 dark:border-gray-800 ${className}`}
      style={{ fontFamily: 'CustomFont' }}
    >
      <Breadcrumb
        items={items}
        separator="/"
        className="text-sm"
      />
    </div>
  );
};

export default EntityBreadcrumb;
